export const ESTADO_CONCILIACION = {
  SIN_CONCILIAR: 1,
  CONCILIADO: 2,
  EXCLUIDO: 3,
} as const

export type EstadoConciliacionType =
  (typeof ESTADO_CONCILIACION)[keyof typeof ESTADO_CONCILIACION]
